import DATA_HUB_URLS from "./urls";

export default [
  {
    appTitle: true,
    header: "Data Hub",
    icon: "fa-kit fa-hdp-app-data-hub",
    baseRoute: DATA_HUB_URLS.baseUrl,
  },
  {
    header: "Data Model",
    children: [
      {
        name: "Catalog Overview",
        route: DATA_HUB_URLS.DATA_MODEL_CATALOG_OVERVIEW,
        permissions: ["data_model.view_datamodel"],
      },
      {
        name: "Lineage Graph",
        route: DATA_HUB_URLS.DATA_MODEL_LINEAGE_GRAPH,
        permissions: ["lineage.view_lineagegraph"],
      },
      // Nov 2025 - ERD temporarily removed. Can still be accessed via router but hidden to user until product figures out what they
      // want to fully do with it.
      // {
      //   name: "ERD",
      //   route: DATA_HUB_URLS.DATA_MODEL_ERD,
      //   permissions: ["data_model.view_datamodel"],
      // },
    ],
  },
  {
    header: "Orchestration",
    children: [
      {
        name: "Data Mapping",
        route: DATA_HUB_URLS.ORCHESTRATION_DATA_MAPPING,
        permissions: ["data_mapping.view_configuration"],
      },
      {
        name: "Quality Catalog",
        route: DATA_HUB_URLS.ORCHESTRATION_DATA_CATALOG,
        permissions: ["data_quality.view_dataqualitytest"],
      },
      {
        name: "Data Test",
        route: DATA_HUB_URLS.ORCHESTRATION_DATA_TEST,
        permissions: ["data_quality.view_mappingtest"],
      },
      {
        name: "Configuration Hub",
        route: `${DATA_HUB_URLS.ORCHESTRATION_CONFIGURATION_HUB}`,
        permissions: ["orchestration.view_source"],
      },
      {
        name: "Connections",
        route: DATA_HUB_URLS.ORCHESTRATION_CONNECTIONS,
        permissions: ["orchestration.view_connection"],
      },
      {
        name: "Data Monitors",
        route: DATA_HUB_URLS.ORCHESTRATION_DATA_MONITORS,
        permissions: ["data_monitor.view_datamonitor"],
      },
    ],
  },
  {
    header: "Transformation",
    children: [
      {
        name: "Recoding",
        route: DATA_HUB_URLS.TRANSFORMATION_RECODING,
        permissions: ["recode.view_ruleset"],
      },
      {
        name: "Value Lists",
        route: DATA_HUB_URLS.TRANSFORMATION_VALUE_LISTS,
        permissions: ["value_list.view_valuelist"],
      },
      {
        name: "Managed Tables",
        route: DATA_HUB_URLS.TRANSFORMATION_MANAGED_TABLES,
        permissions: ["custom_tables.view_customtable"],
      },
    ],
  },

  {
    header: "Monitoring",
    children: [
      {
        name: "Orchestration Jobs",
        route: DATA_HUB_URLS.ORCHESTRATION_MONITORING,
        permissions: ["monitoring.view_pipelinejob"],
      },
      {
        name: "Data Mapping",
        route: DATA_HUB_URLS.DATA_MAPPING_MONITORING,
        permissions: ["data_mapping.view_configuration"],
      },
      {
        name: "Data Processing",
        route: DATA_HUB_URLS.OPERATIONS_MONITORING_DATA_PROCESSING,
        permissions: ["monitoring.view_filerecord"],
      },
      {
        name: "Job Processing",
        route: DATA_HUB_URLS.OPERATIONS_MONITORING_JOB_PROCESSING,
        permissions: ["monitoring.view_processevent"],
      },
      {
        name: "Activity Stream",
        route: DATA_HUB_URLS.ACTIVITY_STREAM,
        permissions: ["auditlog.view_logentry"],
      },
    ],
  },
];
